import {createStrokeSVG} from './TEMPLATE'

// lucide: pencil
export const PencilLine_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z',
    'm15 5 4 4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// lucide: pencil
export const PencilLine_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z',
    'm15 5 4 4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// lucide: pencil
export const Pencil_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z',
    'm15 5 4 4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
